// src/pages/ModernSlavery2021.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function ModernSlavery2021() {
  return (
    <section className="w-full bg-primary text-white relative">
      <div className="max-w-5xl mx-auto px-4 py-16 md:pt-40 flex flex-col md:flex-row items-center">
        <h1 className="text-brandAccent text-4xl md:text-5xl font-extrabold mb-4">
          Modern Slavery Statement &ndash; 2021
        </h1>
      </div>
      <article className="bg-white text-primary p-32 rounded-tl-3xl">
        {" "}
        {/* <h1 className="text-4xl font-extrabold mb-4">
          Modern Slavery Statement &ndash; 2021
        </h1>
        <hr className="border-gray-200 mb-8" /> */}
        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-3">INTRODUCTION TO ZORQK</h2>
          <p>
            ZORQK Cars Limited (referred to in this Modern Slavery Statement as
            “ZORQK”) operates ZORQK.co.uk, offering a direct-to-consumer
            e-commerce platform for quality-checked cars.
          </p>
          <p className="mt-4">
            ZORQK is part of the Constellation Automotive Group (the “Group”)
            which operates a market-leading business across the UK and Europe.
          </p>
          <p className="mt-4">
            The registered office for ZORQK Cars Limited at the date of this
            statement is Form 2, 18 Bartley Wood Business Park, Bartley Way,
            Hook, Hampshire, RG27 9XA.
          </p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-3">WHAT IS MODERN SLAVERY?</h2>
          <p>
            Modern slavery is a serious crime and a violation of fundamental
            human rights. It takes various forms, such as slavery, servitude,
            forced and compulsory labour and human trafficking, all of which
            have in common the deprivation of a person’s liberty by another in
            order to exploit them for personal or commercial gain.
          </p>
          <p className="mt-4">ZORQK acknowledge that companies:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>
              have a vital role to play in conducting business in such a manner
              to prevent modern slavery;
            </li>
            <li>… and so on.</li>
          </ul>
        </section>
        <div className="mt-12">
          <Link
            to="/policies/modern-slavery-statement"
            className="underline text-accent"
          >
            ← Back to statements
          </Link>
        </div>
      </article>
    </section>
  );
}
